<template>
  <b-modal
    id="no-course-modal"
    size="lg"
    hide-header
    hide-footer
    centered
    modal-class="no-course-modal text-center"
  >
    <p>
      <b>Course Not Started Yet!</b> <br />
      You Will get notification when the course starts if you subscribe the
      course
    </p>
  </b-modal>
</template>

<script>
export default {
  name: "no-course-notification"
};
</script>

<style scoped></style>
